import { render, staticRenderFns } from "./videoPlayback.vue?vue&type=template&id=d63fa8de&scoped=true"
import script from "./videoPlayback.vue?vue&type=script&lang=js"
export * from "./videoPlayback.vue?vue&type=script&lang=js"
import style0 from "./videoPlayback.vue?vue&type=style&index=0&id=d63fa8de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63fa8de",
  null
  
)

export default component.exports